import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=252536e4&"
import script from "./testimonial.vue?vue&type=script&lang=js&"
export * from "./testimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports